import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ index, overline, title, sub, align = "left" }) => (
  <div className={`mb-14 md:mb-20 ${align === "center" ? "text-center" : ""}`} data-testid={`section-header-${index}`}>
    <Reveal>
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-smipl-orange mb-5">
        {String(index).padStart(2, "0")} <span className="text-white/30 mx-2">/</span> {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">{title}</h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base md:text-lg text-slate-400 max-w-2xl leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
